import { CodeComponentPropUsage } from "./SDKCodeComponentPropUsage";
export class CodeComponentUsage {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // Constructor
    constructor(model) {
        this.componentName = model.componentName;
        this.componentPackageName = model.componentPackageName;
        this.usageRepositoryName = model.usageRepositoryName;
        this.usagePackageName = model.usagePackageName;
        this.usages = model.usages;
        this.usageFiles = model.usageFiles;
        this.props = Object.fromEntries(Object.entries(model.props).map(([key, value]) => [
            key,
            new CodeComponentPropUsage(value),
        ]));
    }
}
